<template>
    <!-- Snackbar for alert notifications -->
    <v-snackbar
        v-model="notification"
        bottom
        left
        :color="type"
        :timeout="timeout"
    >
      {{ notificationText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-if="hasButton"
          :color="buttonColor"
          @click="closeNotification"
          text
          v-bind="attrs"
        >
          {{ buttonText }}
        </v-btn>
      </template>
    </v-snackbar>
</template>

<script>

import { EventBus } from '../../mixins'

export default {
  data: function () {
    return ({
      buttonColor: '',
      buttonText: '',
      hasButton: true,
      notificationText: '',
      notification: false,
      timeout: 4000,
      type: null
    })
  },
  methods: {
    /**
             * Snackbar options
             * @param text               - Snackbar text
             * @param options.buttonText - Button text
             * @param options.closeable  - Whether snackbar is closeable
             * @param options.onClick    - Button handler
             * @param options.timeout    - Snackbar timeout
             * @param options.type       - Snackbar type
             */
    addNotification (params) {
      const text = params.text
      const options = params.options ? params.options : {}

      // Hide previous notification
      this.notification = false

      // Display new notification (but give time for previous to disappear)
      setTimeout(() => {
        this.notificationText = text
        this.notification = true

        // Customization
        this.buttonColor = options.type ? 'white' : 'pink'
        this.buttonText = options.buttonText ? options.buttonText : ''
        this.hasButton = options.buttonText && options.onClick
        this.onClick = options.onClick ? options.onClick : null
        this.timeout = options.timeout ? options.timeout : 4000
        this.type = options.type ? options.type : null

        // Closeable snackbars override other properties
        if (options.closeable) {
          this.buttonText = 'Close'
          this.hasButton = true
          this.onClick = this.closeNotification
        }
      }, 100)
    },
    /**
             * Close the snackbar and execute callback
             */
    clickHandler (callback) {
      this.closeNotification()
      callback()
    },
    /**
             * Close the snackbar
             */
    closeNotification () {
      this.notification = false
    }
  },
  mounted () {
    // Listen for the show-notification event and its payload.
    EventBus.$on('show-notification', this.addNotification)
  }
}

</script>
